import { mapMutations } from 'vuex'
import moment from 'moment-timezone'

export const dashboardReportsMixins = {
  data() {
    return {}
  },
  computed: {
    computedDate1Formatted() {
      if (this.selectedFilters.timeFrameOption === "Time Range") {
        if (!this.dates[0]) {
          this.dates[0] = new Date(new Date().valueOf() - 1000 * 60 * 60 * 24)
            .toISOString()
            .substr(0, 10);
          return this.formatDate(this.dates[0]);
        }
        return this.formatDate(this.dates[0]);
      }
    },
    computedDate2Formatted() {
      if (this.selectedFilters.timeFrameOption === "Time Range") {
        this.menu1 = false;
        if (!this.dates[1]) {
          this.dates[1] = new Date(
            Date.now() - new Date().getTimezoneOffset() * 60000
          )
            .toISOString()
            .substr(0, 10);
          this.goButtonDisable = false;
          return this.formatDate(this.dates[1]);
        }
        return this.formatDate(this.dates[1]);
      }
    },
  },
  methods: {
    formatDate(date) {
      if (!date) return null

      const [year, month, day] = date.split('-')
      return `${month}/${day}/${year}`
    },
    reportsCardsUIElements() {
      return {
        totalAccounts: {
          color: '#607D8B',
          icon: 'mdi-account-multiple'
        },
        activeAccounts: {
          color: '#6A1B9A',
          icon: 'mdi-account-check'
        },
        search: {
          color: '#3F51B5',
          icon: 'mdi-account-search'
        },
        create: {
          color: '#F44336',
          icon: 'person_add'
        },
        update: {
          color: '#64B5F6',
          icon: 'mdi-account-edit'
        },
        link: {
          color: '#FF9800',
          icon: 'mdi-link-variant'
        },
        login: {
          color: '#4CAF50',
          icon: 'mdi-login'
        },
      }
    },
    exportAdminReports(data) {
      // Exports All accounts reports
      let headers = 'Time, Agent Login Count,Search Record Count, Link Record Count, Create Record Count, Update Record Count\n'
      let line = data.counts;
      let csv = '\ufeff' + headers;
      csv += line
      var blob = new Blob([csv], { "type": "csv/plain" });
      let link = document.createElement('a')
      link.href = window.URL.createObjectURL(blob)
      link.download = this.getFileName(data);
      link.click()
    },
    filterAccountId(data) {
      if (data.length) {
        const lastIndex = data.lastIndexOf('(')
        if (lastIndex > -1) {
          const accountId = data.substring(lastIndex + 1, data.length - 1)
          return accountId
        }
        return data
      }
    },
    getFileName(data) {
      if (data.accountOption === 'All Accounts') {
        if (data.timeFrameOption === 'Today') {
          const todayDate = new Date().toJSON().slice(0, 10);
          return `crmconnect-${todayDate}.csv`
        } else {
          const fromDate = data.dates[0];
          const toDate = data.dates[1];
          return `crmconnect-${fromDate}_${toDate}.csv`
        }
      } else {
        const accountId = this.filterAccountId(data.accountOption);
        if (data.timeFrameOption === 'Today') {
          const todayDate = new Date().toJSON().slice(0, 10);
          return `crmconnect-${accountId}-${todayDate}.csv`
        } else if (data.timeFrameOption === 'Since Inception') {
          return `crmconnect-${accountId}-all.csv`
        } else {
          const fromDate = data.dates[0];
          const toDate = data.dates[1];
          return `crmconnect-${accountId}-${fromDate}_${toDate}.csv`
        }
      }
    },
    ...mapMutations({
      setSnack: 'setSnack'
    }),
    preparePayload() {
      const selectedTimeZone = JSON.parse(sessionStorage.getItem("user")).timeZone;
      const offset = moment.tz(selectedTimeZone).utcOffset();

      let payload = {
        graphTitle: '',
        timezone: selectedTimeZone,
      };

      // Today's
      if (this.selectedFilters.timeFrameOption === "Today") {
        payload.graphTitle = 'Report from 12AM to now'

        const fromTimeStamp = moment().tz(selectedTimeZone).startOf('day').valueOf() + (offset * 60000); // Midnight epochtime
        const toTimeStamp = moment().tz(selectedTimeZone).valueOf() + (offset * 60000); //Current epochtime

        payload.timeframe = {
          from: fromTimeStamp,
          // to: toTimeStamp,
          to: toTimeStamp + (60*60*1000), // Adding 1hr extra get real-time reports
        };

        return payload;
      }
      // Time range
      else if (this.selectedFilters.timeFrameOption === "Time Range") {
        // Selected Timeframe is TimeRange so enabling datepicker text-field
        this.datePickerDisable = false;

        if (!this.dates) this.dates = this.selectedFilters.dates;

        if (this.dates.length === 2) {
          // For TimeRange selected 2 dates enabling GO button
          this.menu = false;
          this.goButtonDisable = false;
          this.selectedFilters.dates = this.dates;
          // Preaparing payload timeframe if go button click is true
          if (this.goButtonClicked) {
            payload.timeframe = {};
            this.dates = this.dates.sort();
            // Graph title with from and to dates
            const from = this.formatDate(this.dates[0])
            const to = this.formatDate(this.dates[1])
            payload.graphTitle = `Report from ${from} to ${to}`

            const fromTimeStamp = new Date(this.dates[0]).setUTCHours(0,0,0,0); // First Date Midnight 12:00AM epochtime
            const toTimeStamp = new Date(this.dates[1]).setUTCHours(23,59,59,999); // Second Date End 23Hr:59Min:59Sec:999ms PM epochtime

            payload.timeframe = {
              from: fromTimeStamp,
              to: toTimeStamp,
            };
          }
        } else if (this.dates.length === 1) {
          this.menu = false;
        }
        return payload;
      }
      // Since Inception
      else if (this.selectedFilters.timeFrameOption === "Since Inception") {
        // Approved Date
        const userInfo = JSON.parse(sessionStorage.getItem("user"));
        let approvedDate = '0';
        const selectedAccount = this.filterAccountId(this.selectedFilters.accountOption)
        if (userInfo.role === 'admin') {
          for (let i = 0; i < userInfo.value.data.length; i++) {
            let eachUser = userInfo.value.data[i];
            if (eachUser.accountId === selectedAccount) {
              approvedDate = eachUser.approvedDate;
              break
            }
          }
        } else {
          approvedDate = userInfo.value.data ? userInfo.value.data.approvedDate : '0';
        }

        let fromDate = new Date(parseInt(approvedDate))
        fromDate = fromDate.getMonth() + 1 + '/' + fromDate.getDate() + '/' + fromDate.getFullYear();
        payload.graphTitle = `Report from ${fromDate} to now`


        const fromTimeStamp = parseInt(approvedDate); // Approved date
        const toTimeStamp = moment().tz(selectedTimeZone).valueOf() + (offset * 60000); // Current epochtime

        // Payload timeframe
        payload.timeframe = {
          from: fromTimeStamp,
          // to: toTimeStamp,
          to: toTimeStamp + (60*60*1000), // Adding 1hr extra get real-time reports
        };
        return payload;
      }
    },
    scrollToTop() {
      window.scrollTo(0, 0);
    },
    showSnack: function (snack, isError) {
      const setSnackObj = {
        message: snack,
        isError: !!isError
      }
      this.setSnack(setSnackObj)
    },
    async preparingReports(data) {

      const response = data.value.data;
      let extractReports = {
        exportMetrics: '',
        graphMetrics: {
          yAxisMaxProp: 0,
          graphTitle: ''
        },
      }

      if (response.unit === 'hour') {
        extractReports.graphMetrics.graphTitle = 'Hourly';
      } else if (response.unit === 'day') {
        extractReports.graphMetrics.graphTitle = 'Daily';
      } else if (response.unit === 'week') {
        extractReports.graphMetrics.graphTitle = 'Weekly';
      } else if (response.unit === 'month') {
        extractReports.graphMetrics.graphTitle = 'Monthly';
      } else if (response.unit === 'year') {
        extractReports.graphMetrics.graphTitle = 'Yearly';
      }

      // Graph Data
      await Object.keys(response).map(async (key, data) => {
        let eachObj = response[key]

        if (eachObj instanceof Array) {
          let dataPoints = {
            xPoints: [],
            yPoints: []
          }
          // Preparing x-axis and y-axis datapoints
          await eachObj.map((obj) => {
            // X-axis points
            if (response.unit === 'hour') {
              // Converting yyyy-mm-dd/hour to hour(AM/PM)
              let time = Object.keys(obj)[0];
              time = time.split('/')
              if (time[1] === '0' || time[1] === '24') {
                time = `12AM`
              } else {
                time = `${(time[1] % 12 || 12)}${(time[1] < 12 ? 'AM' : 'PM')}`
              }
              dataPoints.xPoints.push(time);

            } else if (response.unit === 'day') {
              // Converting yyyy-mm-dd to mm/dd/yyyy
              const day = this.formatDate(Object.keys(obj)[0]);
              dataPoints.xPoints.push(day);

            } else if (response.unit === 'week') {
              // Converting yyyy-mm-dd to mm/dd/yyyy
              let weekStartDay = new Date(Object.keys(obj)[0]);
              let weekLastDay = weekStartDay.getDate() - (weekStartDay.getDay() - 1) + 6;
              weekLastDay = new Date(new Date(Object.keys(obj)[0]).setDate(weekLastDay));
              weekLastDay = weekLastDay.getMonth() + 1 + '/' + weekLastDay.getDate() + '/' + weekLastDay.getFullYear();

              if (weekStartDay && weekLastDay) {
                weekStartDay = this.formatDate(Object.keys(obj)[0]);

                if (this.selectedFilters.timeFrameOption === 'Time Range') {
                  // For Time Range Comapring selected end date with weekLastDay
                  const endDate = this.formatDate(this.selectedFilters.dates[1])
                  const d1 = Date.parse(endDate);
                  const d2 = Date.parse(weekLastDay);
                  if (d1 < d2) {
                    weekLastDay = endDate;
                  }
                } else {
                  // For Since-Inception Comapring  weekLastDay with today date
                  const todayDate = this.formatDate(new Date().toISOString().split('T')[0])
                  const d1 = Date.parse(todayDate);
                  const d2 = Date.parse(weekLastDay);
                  if (d1 < d2) {
                    weekLastDay = todayDate;
                  }
                }
                dataPoints.xPoints.push(`${weekStartDay}-${weekLastDay}`);
              }
            } else if (response.unit === 'month') {
              // Converting yyyy-mm to Monthname yyyy
              let month = Object.keys(obj)[0];
              month = month.split('-');
              month = `${moment(month[1], 'MM').format('MMMM')} ${month[0]}`;
              dataPoints.xPoints.push(month);

            } else if (response.unit === 'year') {
              dataPoints.xPoints.push(Object.keys(obj)[0]);
            }

            // Y-axis points
            dataPoints.yPoints.push(Object.values(obj)[0]);
            // Yaxis max prop
            if (extractReports.graphMetrics['yAxisMaxProp'] < Object.values(obj)[0]) {
              extractReports.graphMetrics['yAxisMaxProp'] = Object.values(obj)[0];
            }

          });

          extractReports.graphMetrics[key] = dataPoints;
        }
      });

      // Preapring export data lines
      const yPointsLen = extractReports.graphMetrics['SEARCH_RECORD'].yPoints.length;

      for (let i = 0; i < yPointsLen; i++) {
        const time = extractReports.graphMetrics['LOGIN_RECORD'].xPoints[i]
        const loginCount = extractReports.graphMetrics['LOGIN_RECORD'].yPoints[i];
        const searchCount = extractReports.graphMetrics['SEARCH_RECORD'].yPoints[i]
        const linkCount = extractReports.graphMetrics['LINKTRANSCRIPT_RECORD'].yPoints[i]
        const createCount = extractReports.graphMetrics['CREATE_RECORD'].yPoints[i]
        const updateCount = extractReports.graphMetrics['UPDATE_RECORD'].yPoints[i]

        extractReports.exportMetrics += `${time},${loginCount},${searchCount},${linkCount},${createCount},${updateCount}\n`;
      }

      return extractReports;
    }
  },
  watch: {
    chartData: function (newVal) {
      this.renderChat = true;
    },
    dates: function () {
      this.goButtonClicked = false;
      if (this.selectedFilters.timeFrameOption === "Time Range") {
        if (this.dates.length === 1) {
          this.goButtonDisable = true;
        } else if (this.dates.length === 2) {
          this.goButtonDisable = false;
        }
      }
    },
  },
};